import { render, staticRenderFns } from "./crowded.vue?vue&type=template&id=056b1ee4&scoped=true&"
import script from "./crowded.vue?vue&type=script&lang=js&"
export * from "./crowded.vue?vue&type=script&lang=js&"
import style0 from "./crowded.vue?vue&type=style&index=0&id=056b1ee4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b1ee4",
  null
  
)

export default component.exports